import { IconButton, Tooltip } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import { FC } from "react";
import { gameState } from "@/services/gameState";
import { PdfData } from "@/models/pdfData";

const OpenScoreSheetButton: FC<{ game?: PdfData }> = ({ game }) => {
  const scoresheetPdfUrl = gameState("scoresheetPdfUrl");
  const passedUrl = game?.gameData.scoresheetPdfUrl;

  const url = game ? passedUrl : scoresheetPdfUrl;

  return (
    <Tooltip
      title={url ? "Spielprotokoll öffnen" : "Spielprotokoll URL unbekannt"}
    >
      <span>
        <IconButton onClick={() => window.open(url)} disabled={!url}>
          <PictureAsPdf />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default OpenScoreSheetButton;
